// extracted by mini-css-extract-plugin
module.exports = {"section":"AboutUs_section__2DDkd"};